import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AuthService } from '../../../auth/data-access/auth.service';
import { AccountService } from '../../../account/data-access/account.service';
import {MatDividerModule} from '@angular/material/divider'
import {MatListModule} from '@angular/material/list'
import { toSignal } from '@angular/core/rxjs-interop';
import { InitialsPipe } from '../../../../shared/pipes/initials.pipe';
import { Router, RouterModule } from '@angular/router';
import { ModalService } from '../../../../shared/services/modal/modal.service';
import { PasswordResetSelfComponent } from '../../../../shared/services/modal/components/password-reset-self/password-reset-self.component';

@Component({
  selector: 'profile-page',
  standalone: true,
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    NgxPermissionsModule,
    MatDividerModule,
    MatListModule,
    InitialsPipe,
    RouterModule
  ],
  templateUrl: './profile-page.component.html',
  styleUrl: './profile-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfilePageComponent { 

  public readonly authService: AuthService = inject(AuthService);
  private readonly modalService:ModalService = inject(ModalService);
  public readonly accountService:AccountService = inject(AccountService);

  user = toSignal(this.accountService.me(), {initialValue: null});
  imageLoaded = false;


  resetPassword()
  {
    this.modalService.showComponent<PasswordResetSelfComponent>(PasswordResetSelfComponent,{}).result.subscribe(result => {
      if(!result.success)
        {
          return;
        }

      this.accountService.resetPassword(result.model).subscribe()
    })
  }


}
